import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { useAuthStore, useUserStore } from '../../stores';

function RequireRiderAuth() {
  const { isAuth } = useAuthStore();
  const { userType } = useUserStore();

  const location = useLocation();

  return isAuth && userType === 'rider' ? (
    <Outlet />
  ) : (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  );
}

export default RequireRiderAuth;
